import { withViewComponent } from '@updater-local/custom-element-v1';
import '@updater-components/card';
import '../company-description';
import '../company-logo';
import styles from './index.css';
import { when } from '../../utils';

export default class CompanyProfileCard extends withViewComponent(styles)() {
  static props = ['value'];

  updated({
    value: {
      logo,
      name,
      yearOfEstablishment,
      numberOfMoves,
      numberOfTrucks,
      address: { city, postalCode, state, street },
      website,
      rating: { qualityRating },
    },
  }) {
    const websiteUrl = normalizeUrl(website);

    // prettier-ignore
    this.render`
      <upd-card>
        <upd-moveiq-company-logo id="logo" value="${logo}" alt="${name}"></upd-moveiq-company-logo>

        <div>${name}</div>

        <upd-moveiq-company-description value="${{ yearOfEstablishment, numberOfMoves, numberOfTrucks }}"></upd-moveiq-company-description>

        <!-- Cannot call this \`footer\` since the name collides with \`upd-card\`'s footer. Might be a shadowDOM bug. -->
        <slot name="misc-footer"></slot>

        <div id="details" slot="footer">
          ${when(qualityRating, () => this.wire()`
            <div class="detail">
              <span class="title">Quailty Rating</span>
              <span id="rating">${qualityRating}</span>
            </div>
            <hr>
          `)}

          <div class="detail">
            <span class="title">Address</span>
            <span>${street}</span>
            <span>${city + ', ' + state + ' ' + postalCode}</span>
          </div>
          <div class="detail">
            <span class="title">Website</span>
            <a
              href="${websiteUrl}"
              data-analytics-properties-url="${websiteUrl}"
              target="_blank"
              data-analytics-event="Company Profile Website"
            >
              ${website}
            </a>
          </div>
        </div>
      </upd-card>
    `;
  }
}

customElements.define('upd-moveiq-company-profile-card', CompanyProfileCard);

function normalizeUrl(url) {
  return url.indexOf('://') === -1 ? 'http://' + url : url;
}
